import React from "react";
import { Button } from "react-bootstrap";
import { filter } from "lodash";

import Tableau from "../../containers/Tableau";

import Compo from "../Compo";
const IndicesMenu = ({
	refIndic,
	currentCompo,
	currentIndic,
	clickCompo,
	territoire,
	niveau = 5,
	composition = null,
	expanded,
	bsCol,
}) => {
	return (
		<nav className="indicators-menu">
			{filter(
				refIndic,
				(compo) =>
					compo.niveau === niveau &&
					(composition === null || composition.includes(compo.id))
			).map((compo) => {
				if (compo.id === "I")
					return (
						<div key={compo.id} className={bsCol[compo.id]}>
							<div>
								<Button
									block
									className={
										compo.id === currentCompo
											? expanded
												? "active expanded"
												: "active"
											: null
									}
									onClick={() => clickCompo(compo.id)}>
									<span>{compo.description.toUpperCase()}</span>
									<i className="far fa-angle-right"></i>
								</Button>
								{(!currentCompo || compo.id === currentCompo) && <Tableau />}
								{niveau > 3 && (
									<Compo
										refIndic={refIndic}
										currentCompo={currentCompo}
										currentIndic={currentIndic}
										clickCompo={clickCompo}
										territoire={territoire}
										niveau={niveau - 1}
										composition={compo.composition}
									/>
								)}
							</div>
						</div>
					);
				return null;
			})}
		</nav>
	);
};

export default IndicesMenu;
